import { createAction } from "redux-act";

// Clear auth action - no payload needed as we're resetting to initial state
export const clearAuth = createAction('clearAuth');

